var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "ButtonsIcon",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        icon: "mdi-delete-outline",
                        color: "red",
                        small: "",
                      },
                      on: {
                        clicked: function ($event) {
                          return _setup.emit("clicked", $event)
                        },
                      },
                    },
                    "ButtonsIcon",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Excluir")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }